import React, { useState, useEffect } from "react";
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { Link } from 'react-router-dom';

//imported
import { FAQ, TRASH_BIN } from "common/viewContent";
import * as actions from 'store/actions';
import * as Path from 'routes/paths';
import { useGetTrashBinItem, useRestoreItem } from "hooks/reactQuery/useTrashBin";
import { DATE_FORMAT, userFullName } from "helpers/common";
import Skeleton from "react-loading-skeleton";
import RestoreConfirmationPopup from "./Components/RestoreConfirmationPopup";
import { Button } from "react-bootstrap";
import { generatePath } from "react-router-dom/cjs/react-router-dom.min";
import EntityDetails from "./Components/EntityDetails";
import moment from "moment";

const View = ({ submitting, dispatch, match }) => {
    let editkey = match.params.id;

    const [showRestoreConfirmPopup, setShowRestoreConfirmPopup] = useState(false);

    const { data: response, isLoading, refetch } = useGetTrashBinItem(editkey);

    const data = response?.body;

    const {
        mutateAsync: restoreItem,
        isPending,
        isError,
        error,
    } = useRestoreItem();

    const handleRestore = async () => {
        try {
            const result = await restoreItem(data.id);

            console.log("result", result);
            await refetch();
        } catch (err) {
            console.error("Error restoring item", err);
        }
    };

    const openRestoreConfirmPopup = () => {
        setShowRestoreConfirmPopup(true);
    }

    const closeRestoreConfirmPopup = () => {
        setShowRestoreConfirmPopup(false);
    }

    return (
        <>
            <Helmet title={TRASH_BIN.CURRENT_MODULE} />
            <RestoreConfirmationPopup
                showPopup={showRestoreConfirmPopup}
                closePopup={closeRestoreConfirmPopup}
                currentItem={data}
                handleRestore={handleRestore}
            />
            <section className="section">
                <div className="section-header">
                    <h1>{TRASH_BIN.CURRENT_MODULE}</h1>
                    <div className="section-header-breadcrumb">

                        <div className="breadcrumb-item"><Link to={Path.subscriptions}>{TRASH_BIN.CURRENT_MODULE}</Link></div>
                        <div className="breadcrumb-item">Trash Bin Item Details</div>
                    </div>
                </div>
                {/* {!props.loader && */}
                <div className="section-body">
                    <div className="section-top row align-items-center">
                        <div className="col-10">
                            <h2 className="section-title mt-0">Trash Bin Item Details</h2>
                            <p className="section-lead">
                                View complete information about the deleted item, including its status, reason, and related entity details.
                            </p>
                        </div>
                        <div className="col-2 text-center">
                            {!isLoading && data?.status === "trashed" && (
                                <Button
                                    // variant="transparent"
                                    onClick={() => openRestoreConfirmPopup(data)}
                                    title="Restore"
                                    className="btn btn-primary"
                                >
                                    Restore
                                </Button>
                            )}
                        </div>
                    </div>
                    <div className="row mt-sm-4">
                        <div className="col-12 col-md-6 col-lg-6">
                            <div className="card">
                                <div className="card-body">
                                    {isLoading && (
                                        <TrashDetailSkeleton />
                                    )}

                                    {!isLoading && data && (
                                        <>
                                            {/* Trash Bin Meta Info */}
                                            <h6 className="text-primary mb-3">Trash Information</h6>

                                            <div className="form-group row">
                                                <label className="col-sm-4 col-form-label">Entity Type</label>
                                                <div className="col-sm-8">
                                                    <p className="form-control-plaintext text-capitalize">
                                                        {data.entity_type}
                                                    </p>
                                                </div>
                                            </div>

                                            <div className="form-group row">
                                                <label className="col-sm-4 col-form-label">Reason</label>
                                                <div className="col-sm-8">
                                                    <p className="form-control-plaintext">
                                                        {data.reason || "-"}
                                                    </p>
                                                </div>
                                            </div>

                                            <div className="form-group row">
                                                <label className="col-sm-4 col-form-label">Status</label>
                                                <div className="col-sm-8">
                                                    <span className="badge badge-danger text-capitalize">
                                                        {data.status === "trashed" ? "deleted" : data.status}
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="form-group row">
                                                <label className="col-sm-4 col-form-label">Deleted By</label>
                                                <div className="col-sm-8">
                                                    <p className="mb-0">
                                                        <Link
                                                            to={generatePath(Path.practitioner_view, { id: data.pract_id })}
                                                            target={"_blank"}
                                                        >
                                                            {userFullName(data)} {data.email ? <span className="text-muted">({data.email})</span> : ""}
                                                        </Link>
                                                    </p>
                                                </div>
                                            </div>

                                            <div className="form-group row">
                                                <label className="col-sm-4 col-form-label">Created At</label>
                                                <div className="col-sm-8">
                                                    <p className="form-control-plaintext">
                                                        {DATE_FORMAT(data.created_at, "MMM D, YYYY H:mm A")}
                                                    </p>
                                                </div>
                                            </div>

                                            <div className="form-group row">
                                                <label className="col-sm-4 col-form-label">Expires At</label>
                                                <div className="col-sm-8">
                                                    <p className="form-control-plaintext">
                                                        {DATE_FORMAT(data.expire_at, "MMM D, YYYY H:mm A")} <span className="text-muted">({moment(data.expire_at).fromNow()})</span>
                                                    </p>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </div>

                            </div>
                        </div>
                        <div className="col-12 col-md-6 col-lg-6">
                            <div className="card">
                                <div className="card-body">
                                    {isLoading && (
                                        <TrashDetailSkeleton />
                                    )}

                                    {!isLoading && data && (
                                        <EntityDetails
                                            data={data}
                                        />
                                    )}
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                {/* } */}
            </section>
        </>
    )
}

const TrashDetailSkeleton = () => {
    return (
        <>
            <h6 className="mb-3">
                <Skeleton width={180} height={20} />
            </h6>

            {[...Array(6)].map((_, index) => (
                <div className="form-group row" key={index}>
                    <div className="col-sm-4">
                        <Skeleton height={20} />
                    </div>
                    <div className="col-sm-8">
                        <Skeleton height={20} />
                    </div>
                </div>
            ))}
        </>
    );
};


const mapStateToProps = (state) => {
    return {
        faqDetail: state.Faq.faq,
        loader: state.Faq.loader
    }
};

function mapDispatchToProps(dispatch) {
    return { dispatch };
}

export default connect(mapStateToProps, mapDispatchToProps)(View);